var _defs, _rect, _g, _circle, _circle2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0A1C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2537"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#g2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeOpacity: 0.05,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: -100,
    y1: 900,
    x2: 900,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 900,
    x2: 1100,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 900,
    x2: 1300,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 900,
    x2: 1500,
    y2: -100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 900,
    x2: 1700,
    y2: -100
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 720,
    r: 150,
    fill: "none",
    stroke: "#C81E2B",
    strokeOpacity: 0.4,
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 720,
    r: 90,
    fill: "#C81E2B",
    opacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 860,
    width: 1600,
    height: 10,
    fill: "#C81E2B",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero2);
export default __webpack_public_path__ + "static/media/hero2.40d43b8b6455de8b069976022facf65a.svg";
export { ForwardRef as ReactComponent };